import { FC } from 'react'
import { GRAY_900 } from 'constants/styling/theme'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import { Nullable } from 'models/helpers'
import { StarRatingInput } from '../StarRatingInput'
import { StarRatingValue } from 'constants/misc'

type LabelVariant = 'text-sm' | 'text-md' | 'text-lg'

interface Props {
  /** Translated dimension label (e.g. "Visual quality") */
  label: string
  /** Current rating value */
  value: Nullable<StarRatingValue>
  /** Called when user selects a rating */
  onChange: (value: StarRatingValue) => void
  /** If true, the rating is read-only */
  readOnly?: boolean
  /** Typography variant for the label */
  labelVariant?: LabelVariant
  /** Font weight for the label */
  labelFontWeight?: number
}

/**
 * Displays a single rating dimension with a label and star input.
 *
 * @example
 * <StarRatingDimension label="Visual quality" value={4} onChange={setRating} />
 */
export const StarRatingDimension: FC<Props> = ({
  label,
  value,
  onChange,
  readOnly = false,
  labelVariant = 'text-sm',
  labelFontWeight = 500
}) => (
  <Stack gap=".8rem">

    <Typography variant={labelVariant} fontWeight={labelFontWeight} color={GRAY_900}>
      {label}
    </Typography>

    <StarRatingInput
      value={value}
      onChange={onChange}
      readOnly={readOnly}
    />

  </Stack>
)
